import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { TimezonePicker as BaseTimezonePicker } from '@calendly/timezone-tools/timezone-picker';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { ArrowChevronUpMiniIcon, ArrowChevronDownMiniIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { timeNotationSelector } from 'selectors/current_user';
const containerCss = "c1j073uh";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const controlToggledCss = "c1dkli8c";
const controlCss = "c13g5vna";
const Control = forwardRef((props, ref) => {
  const {
    toggled,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(controlCss, {
    [controlToggledCss]: toggled
  }, props.className)} />;
});
const timezoneOptionsCss = "t1c6njiw";
const TimezoneOptions = forwardRef((props, ref) => <BaseTimezonePicker ref={ref} {...props} className={classNames(timezoneOptionsCss, props.className)} />);
export const TimezonePicker = ({
  defaultOptionLabel,
  name,
  ...props
}) => {
  const [toggleDropdown, Dropdown, isOpen] = useDropdown();
  const [fieldProps, meta, {
    setValue,
    setTouched
  }] = useFormField(name);
  const currentValue = fieldProps.value;
  const timeNotation = useSelector(timeNotationSelector);
  const handleSelect = value => {
    if (currentValue !== value) {
      setValue(value);
    }
    if (currentValue.delta && !meta.touched) setTouched(true);
  };
  return <Container {...props}>
      <BodyText weight="bold" id="timezone-label">
        {I18n.t('publisher.contacts.timezone')}
      </BodyText>
      <Control onClick={toggleDropdown} aria-expanded={isOpen} aria-labelledby="timezone-label" aria-controls="timezone-picker">
        <BodyText weight="standard">{defaultOptionLabel}</BodyText>
        {isOpen ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />}
      </Control>
      <Dropdown>
        <TimezoneOptions id="timezone-picker" data-component="timezone-picker" selectedId={defaultOptionLabel} onChange={handleSelect} timeNotation={timeNotation} {...props} />
      </Dropdown>
    </Container>;
};

require("./timezone_picker.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./timezone_picker.js");